"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const core_1 = require("@material-ui/core");
const __1 = require("../..");
const styles_1 = __importDefault(require("./styles"));
const SessionEndErrorModal = ({ onConfirm, open = false, }) => {
    const classes = styles_1.default();
    const landingSVG = react_1.default.createElement(__1.LandingSVG, null);
    const { t: translate } = react_i18next_1.useTranslation();
    return (react_1.default.createElement(core_1.Dialog, { classes: {
            paper: classes.paper,
        }, open: open },
        react_1.default.createElement("div", { className: classes.dialogContainer },
            react_1.default.createElement(__1.Dialog, { header: {
                    logo: (react_1.default.createElement(__1.CompanyLogo, { className: classes.companyLogo, company: "his", reserveFill: true, scale: 2 })),
                }, body: {
                    className: classes.contentContainer,
                    children: (react_1.default.createElement(__1.ErrorMessage, { className: classes.errorMessageContainer, message: translate('common.errors.sessionEnd.message'), svg: landingSVG, title: translate('common.errors.sessionEnd.title') })),
                }, buttons: {
                    children: (react_1.default.createElement("div", { className: classes.buttonsContainer },
                        react_1.default.createElement(core_1.Button, { id: "session-end-confirm", className: classes.button, color: "primary", fullWidth: true, onClick: () => onConfirm(), variant: "outlined" }, translate('common.errors.sessionEnd.button')))),
                } }))));
};
exports.default = SessionEndErrorModal;
